import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { DadosEmpresaRow } from 'src/modules/serasa/serasa.pj.types'

export type IdentificacaoProps = {
    empresa: DadosEmpresaRow
}

export default function Identificacao({ empresa }: IdentificacaoProps) {
    return (
        <>
            <Divider textAlign="center">Identificação</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem label="Razão Social" value={empresa.identificacao.razao_social} xs={6} />
                <GridItem label="CNPJ" value={empresa.identificacao.cnpj} xs={6} />
                <GridItem label="Nome Fantasia" value={empresa.identificacao.nome_fantasia} xs={6} />
                <GridItem label="Tipo de Sociedade" value={empresa.identificacao.tipo_sociedade} xs={6} />
                <GridItem label="Opção Tributária" value={empresa.identificacao.opcao_tributaria} xs={6} />

                <GridItem
                    label="Data de Fundação"
                    value={
                        empresa.identificacao.data_fundacao
                            ? formatDate(empresa.identificacao.data_fundacao, 'dd/MM/yyyy')
                            : '-'
                    }
                    xs={6}
                />

                <GridItem label="Quantidade de Filiais" value={empresa.identificacao.qtde_filiais?.toFixed(0)} xs={6} />
                <GridItem label="Cidades" value={empresa.identificacao.cidades} xs={6} />
                <GridItem label="Ramo" value={empresa.identificacao.ramo} xs={6} />
                <GridItem label="Código CNAE" value={empresa.identificacao.cnae} xs={6} />
            </Grid>
        </>
    )
}
